import {
    CANDI_WORK_PREFERENCE_REQUEST,
    CANDI_WORK_PREFERENCE_SUCCESS,
    CANDI_WORK_PREFERENCE_FAIL,
} from "../constants/AuthConstant";

const initialState = {
    result: null,
    loading: null,
    error: null
};

const CandidateWorkPreferenceReducer = (state = initialState, action) => {
    switch (action.type) {
        case CANDI_WORK_PREFERENCE_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };

        case CANDI_WORK_PREFERENCE_SUCCESS:
            return {
                ...state,
                result: action.result.data,
                loading: action.payload,
            };

        case CANDI_WORK_PREFERENCE_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        default:
            return state;
    }
};

export default CandidateWorkPreferenceReducer;